import { render, staticRenderFns } from "./tileMain.vue?vue&type=template&id=dda2bf20&scoped=true&"
import script from "./tileMain.vue?vue&type=script&lang=js&"
export * from "./tileMain.vue?vue&type=script&lang=js&"
import style0 from "./tileMain.vue?vue&type=style&index=0&id=dda2bf20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda2bf20",
  null
  
)

export default component.exports